import Button from '@ixigo/iui/Button';
import ListItem from '@ixigo/iui/ListItem';
import ListItemIcon from '@ixigo/iui/ListItemIcon';
import ListItemText from '@ixigo/iui/ListItemText';
import Typography from '@ixigo/iui/Typography';
import { FC } from 'react';
import { ACTOR_INFO } from '../../constants/conversation';
import BottomsheetHeader from '../BottomsheetHeader';
import Dialog from '../Dialog';
import { ActiveChatPopupProps } from './index.types';

const ActiveChatPopup: FC<ActiveChatPopupProps> = ({ lastMessage, open, onClose, onResolve, onView }) => (
    <Dialog open={open} classes={{ container: '!min-w-full !max-h-[calc(100%-120px)]' }} onClose={onClose}>
        <BottomsheetHeader onClose={onClose} title='Unresolved Query' />
        <div className='p-20'>
            <div className='flex flex-col gap-15 w-full px-10 py-15 rounded-20 shadow-100 cursor-pointer'>
                <ListItem disablePadding className='gap-10 hover:!bg-inherit'>
                    <ListItemIcon>
                        <img
                            src='https://images.ixigo.com/image/upload/tara_9_2024/34ceb720a38eaea0dabf75fbea8bebb7-pxiyw.png'
                            alt='tara'
                            className='w-40 h-40'
                        />
                    </ListItemIcon>
                    <ListItemText
                        className='overflow-hidden'
                        secondary={
                            <Typography
                                as='div'
                                variant='body-xs'
                                fontWeight='normal'
                                className='overflow-hidden text-ellipsis text-charcoal-600 line-clamp-1'
                                dangerouslySetInnerHTML={{ __html: lastMessage }}
                            />
                        }
                    >
                        <span className='flex flex-row items-center justify-center'>
                            <span>{ACTOR_INFO.bot.name}</span>
                        </span>
                    </ListItemText>
                </ListItem>
            </div>
        </div>
        <div className='flex gap-20 w-full p-20 pt-10'>
            <div className='flex flex-col gap-px w-full text-center'>
                <Button variant='soft' size='lg' className='w-full' onClick={onView}>
                    View
                </Button>
                <Typography variant='body-xs' className='text-charcoal-600'>
                    Continue existing chat
                </Typography>
            </div>
            <div className='flex flex-col gap-px w-full text-center'>
                <Button variant='solid' size='lg' className='w-full' onClick={onResolve}>
                    Resolve
                </Button>
                <Typography variant='body-xs' className='text-charcoal-600'>
                    Start new chat
                </Typography>
            </div>
        </div>
    </Dialog>
);

export default ActiveChatPopup;
